import React, { useState, useEffect } from 'react';
import { Button, Table, Tag, Typography, notification } from 'antd';
import { researchUI } from '../../api';
import CciCloud from '../../common/components/CciCloud/CciCloud';
import { CommonApiFunctions, CommonConstant, ErrorMsg, NOTIFICATION_DURATION, UiURLs } from '../../common/constants';
import { TableAppTags, MLApiRequestTypes } from './constants';
import MLScoreModal from './MLScoreModal';

const { Text } = Typography;

const MLPendingRequests = ({ searchAppId }) => {
    const tableColumn = [
        {
            title: 'Application ID',
            dataIndex: 'application_id',
            key: 'application_id',
            width: '10%',
            render: (text) => (
                <a target={'_blank'} href={`${UiURLs.RESEARCH_UI}${text}`}>
                    {text}
                </a>
            ),
        },
        {
            title: 'Application Name',
            dataIndex: 'Application',
            key: 'application_name',
            render: (text) => <Text>{text.current_name}</Text>,
        },
        {
            title: 'Existing CCI',
            dataIndex: 'prev_cci',
            key: 'prev_cci',
            width: '12%',
            render: (text) => <CciCloud cci={text} showLabel />,
        },
        {
            title: 'AI-Generated CCI',
            dataIndex: 'cci',
            key: 'cci',
            width: '12%',
            render: (text) => <CciCloud cci={text} showLabel />,
        },
        {
            title: 'Tag',
            dataIndex: 'tags',
            key: 'tags',
            width: '12%',
            render: (text) => {
                if (text.includes(TableAppTags.newApp.key)) {
                    return <Tag color='green'>{TableAppTags.newApp.label}</Tag>;
                } else if (text.includes(TableAppTags.existingApp.key)) {
                    return <Tag color='red'>{TableAppTags.existingApp.label}</Tag>;
                } else {
                    return CommonConstant.EMPTY_STRING;
                }
            },
        },
        {
            title: 'AI Execution Date',
            dataIndex: 'updateDate',
            key: 'updateDate',
            width: '15%',
            render: (text) => new Date(text).toDateString(),
        },
        {
            title: 'Assigned To',
            dataIndex: 'assignedTo',
            key: 'assignedTo',
            width: '9%',
            render: (text) => text || '-',
        },
        {
            title: 'Action',
            key: 'action',
            render: (_, row) => {
                return (
                    <>
                        {row.incompleteApp && row.newApp ? (
                            <Text>{CommonConstant.INCOMPLETE_APP}</Text>
                        ) : (
                            <Button
                                type='link'
                                onClick={() => {
                                    setApp(row);
                                    setModalVisible(true);
                                }}
                            >
                                {CommonConstant.EVALUATE}
                            </Button>
                        )}
                    </>
                );
            },
        },
    ];

    const [loading, setLoading] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [app, setApp] = useState({});
    const [modalVisible, setModalVisible] = useState(false);
    const [totalEntry, setTotalEntry] = useState(0);
    const [pageConfig, setPageConfig] = useState({ page: 1, pageSize: 10 });

    const fetchTableData = async () => {
        setLoading(true);
        const result = await researchUI({
            function: CommonApiFunctions.ML_SCORE,
            reqType: MLApiRequestTypes.ML_SCORE_TABLE_DATA,
            isHistory: false,
            offset: (pageConfig.page - 1) * pageConfig.pageSize,
            limit: pageConfig.pageSize,
            searchAppId,
        });
        if (result.success) {
            result.data.mlCci.forEach((row) => {
                row.prev_cci = result.data.prev_cci[row.application_id]?.cci;
                row.CciTrend = result.data.prev_cci[row.application_id];
                row.tags = [result.data.new_apps.includes(row.application_id) ? TableAppTags.newApp.key : TableAppTags.existingApp.key];
                row.newApp = result.data.new_apps.includes(row.application_id);
                if (result.data.appProps && result.data.appProps.hasOwnProperty(row.application_id)) {
                    row.incompleteApp = result.data.appProps[row.application_id].incompleteApp;
                } else {
                    row.incompleteApp = false;
                }
                if (result.data.assignedTo.hasOwnProperty(row.application_id)) {
                    row.assignedTo = result.data.assignedTo[row.application_id];
                } else {
                    row.assignedTo = null;
                }
            });
            if (result.data?.totalReq) {
                setTotalEntry(result.data.totalReq);
            }
            setTableData(result.data.mlCci);
        } else {
            notification.error({ message: ErrorMsg.GET_APP_FAILED, description: result.msg, duration: NOTIFICATION_DURATION });
        }
        setLoading(false);
    };

    useEffect(() => {
        fetchTableData();
    }, [pageConfig, searchAppId]);

    const onChangePage = (page, pageSize) => {
        setPageConfig({ page: pageSize !== pageConfig.pageSize ? 1 : page, pageSize });
    };

    const onCloseModal = (reFetchData) => {
        setModalVisible(false);
        if (reFetchData) {
            fetchTableData();
        }
    };

    return (
        <>
            <Table
                loading={loading}
                columns={tableColumn}
                dataSource={tableData}
                pagination={{
                    onChange: onChangePage,
                    total: totalEntry,
                }}
            />
            {modalVisible && <MLScoreModal mlRow={app} visible={modalVisible} onClose={onCloseModal} />}
        </>
    );
};

export default MLPendingRequests;
